<template>
    <div class="background-gradient">
        <slot />
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.background-gradient {
    width: 100%;
    height: 840px;
    background-image: url('/images/promo/connect-features/background-gradient.png');
    background-size: 100% auto, contain;
    background-repeat: no-repeat, no-repeat;
    background-position: top center;

    @media (max-width: 1050px) {
      background-size: 200% auto, contain;
    }

    @media (max-width: 1050px) {
      height: 880px;
    }

    @media (max-width: 720px) {
      height: 1220px;
    }

    @media (max-width: 500px) {
      height: 1180px;
      background-size: 300% auto, contain;
    }
}
</style>
